var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-info",attrs:{"type":"submit"}},[_c('i',{staticClass:"entypo entypo-download"}),_vm._v("\n        Guardar\n    ")])])
}]

export { render, staticRenderFns }